module.exports = __webpack_public_path__ + "img/chofu_service_on.6b7bf80f.svg";